import { cloneDeep, defaultsDeep, isEqual } from 'lodash'

import Fallbacks from '@sigma-legacy-libs/essentials/lib/utils/Fallbacks'

import { proxy } from '@/utils'

import { defaultFallback } from '@/components/rules/utils'

import render from './render'

export default {
  name: 'RulesGeneratorFallbacks',

  mixins: [ proxy({ type: 'array' }) ],

  methods: {
    _inputFilter(data) {
      data = cloneDeep(data)

      return data.map(item => {
        return defaultsDeep(item, defaultFallback)
      })
    },

    _outputFilter(data) {
      return Fallbacks.clean(data)
    },

    transmitValue() {
      const proxy = this._outputFilter(this.proxy)
      if (!isEqual(proxy, this.value)) {
        this.$emit('input', proxy)
      }
    }
  },

  render
}
